import React from 'react'

import { Heading4, Space } from '@gousto-internal/citrus-react'
import classnames from 'classnames'

import type { NutritionFact } from '@library/api-menu-experience'

import css from './NutritionInfo.css'

type NutritionalValueProps = {
  value: string
  loading: boolean
}

type NutritionInfoProps = {
  nutritionValues?: NutritionFact[]
  loading: boolean
  inset?: boolean
}

const NutritionalValue = ({ loading, value }: NutritionalValueProps) =>
  loading ? (
    <span className={css.loadingSkeleton} data-testid="nutritionInfoLoadingSkeleton" />
  ) : (
    <>{value}</>
  )

export const NutritionInfo = ({ nutritionValues, loading, inset = true }: NutritionInfoProps) => {
  if (!nutritionValues?.length) return null

  return (
    <div data-testid="NutritionInfo">
      <Heading4>Nutrition</Heading4>
      <Space size={4} />
      <table className={classnames(css.table, inset && css.tableMargins)}>
        <thead>
          <tr className={css.tableBorder}>
            <th className={css.tablePadding}>Typical Values</th>
            <th className={css.tablePadding}>per 100g</th>
            <th className={css.tablePadding}>per portion</th>
          </tr>
        </thead>
        <tbody>
          {nutritionValues.map(({ name, per100g, perServing }) => (
            <tr key={name} className={css.tableBorder}>
              <td className={css.tablePadding}>{name}</td>
              <td className={css.tablePadding}>
                <NutritionalValue loading={loading} value={per100g} />
              </td>
              <td className={css.tablePadding}>
                <NutritionalValue loading={loading} value={perServing} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
